import get from 'lodash/get';
import {
  PAYMENT_STATUSES,
  APPOINTMENT_STATUSES,
  URGENT_VISIT_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
  TELEMEDICINE_VISIT_TYPE_CODE,
} from '../../../constants';
import { visitExpired } from '../../../utils/appointments/dateFilter';
import { checkMandatoryPaymentWarning } from './appointment';

const { PAID } = PAYMENT_STATUSES;
const { DRAFT, WAITING, UPCOMING, PENDING, IN_PROCESS } = APPOINTMENT_STATUSES;

export function useVirtualVisitGuard({ appointment, isUpcoming }) {
  const hasMandatoryPaymentWarning = checkMandatoryPaymentWarning(appointment);

  const dateTime = get(appointment, 'dateTime');
  const code = get(appointment, 'visitType.code');
  const appointmentStatus = get(appointment, 'status.coreAppName', '');
  const paymentStatus = get(appointment, 'paymentStatus');
  const copay = get(appointment, 'copay');
  const isPaid = paymentStatus === PAID || !copay;
  const patientAllowedStart = get(appointment, 'allowedActions.patientStart');

  const isPendingStatus = appointmentStatus === PENDING;
  const isUpcomingAppointmentStatus = appointmentStatus === UPCOMING;
  const isWaiting = appointmentStatus === WAITING;
  const isInProcess = appointmentStatus === IN_PROCESS;

  const isUrgentVisit = code === URGENT_VISIT_TYPE_CODE;
  const isVirtualVisit = code === VIRTUAL_VISIT_TYPE_CODE;
  const isTelemedicineVisit = code === TELEMEDICINE_VISIT_TYPE_CODE;

  const forUrgentVisit = isUrgentVisit && isPaid && isUpcoming;
  const forVirtualVisit = isVirtualVisit && isUpcoming && !isPendingStatus;
  const forTelemedicineVisit = isTelemedicineVisit && isPaid && isUpcoming;

  const callIsEnabled = isUrgentVisit
    ? isWaiting || isInProcess
    : patientAllowedStart;

  const isExpired = callIsEnabled ? false : visitExpired(dateTime);

  const showVisitBtn =
    (forVirtualVisit || forUrgentVisit || forTelemedicineVisit) &&
    !isExpired &&
    !hasMandatoryPaymentWarning;

  return {
    isUpcomingAppointmentStatus,
    hasMandatoryPaymentWarning,
    showVisitBtn,
    virtualCallEnabled: callIsEnabled,
    ...(isUrgentVisit && {
      isUpcomingAppointmentStatus: [DRAFT, WAITING, IN_PROCESS].includes(
        appointmentStatus,
      ),
    }),
  };
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/useVirtualVisitGuard.js